import React, {useEffect} from 'react';
import {getCalApi} from "@calcom/embed-react";
import ContactModal from "../ContactModal";

function Libre1() {

    useEffect(()=>{
        (async function () {
            const cal = await getCalApi({"namespace":"ligne-inclusion"});
            cal("ui", {"styles":{"branding":{"brandColor":"#000000"}},"hideEventTypeDetails":false,"layout":"month_view"});
        })();
    }, [])

    return (
            <section className="libre layout-pt-50 layout-pb-20 text-center page-lahalle">
                <div className="auto-container">
                    <div className="text-center">
                        <h4 className="libre-title mt-2 mb-4 raleway">
                            <span>Handicap, maladie chronique, difficultés au travail liées à votre santé… un échange peut tout changer !</span>
                        </h4>

                        <div className="nunito">
                            Dans le cadre de l’engagement d’Incluvia pour le handicap et l’inclusion, le service
                            « <b>Hotline Handicap</b> » permet à nos collaborateurs d’échanger en ligne sur rendez-vous
                            avec des experts de notre partenaire Talents Handicap, pour répondre de manière individuelle
                            et anonyme à toutes vos questions concernant le handicap au travail et son lien avec la santé,
                            la prévention et la qualité de vie et des conditions de travail.
                        </div>
                        <h2 className="libre-title mt-2 mb-1 raleway">
                            <div style={{fontSize: "30px"}}>Nos experts sont disponibles <span>chaque mercredi de 14h à 17h</span></div>
                        </h2>
                    </div>

                    <ContactModal
                        textButton="Réserver mon RDV avec un expert"
                        showText={false}
                        small=""
                        linkPageContact={false}
                        iframe={true}
                        couleur={true}
                        page="incluvia"
                    />
                </div>
            </section>
    );
}

export default Libre1;
